import { configure } from "@serverscom/data-role";

// lodash `kebabCase` splits digits off words (`ipv6` -> `ipv-6`, `l2` -> `l-2`), so only camelCase and snake_case are converted
const toKebabCase = (segment: string) =>
  segment
    .replace(/([a-z\d])([A-Z])/g, "$1-$2")
    .replace(/[\s_]+/g, "-")
    .toLowerCase();

const transform = (role: string) => role.replace(/\./g, ":").split(":").map(toKebabCase).join(":");

export const configureDataRoles = (enabled: boolean) => {
  configure({ enabled, separator: ":", transform });
};
